import { Component, inject, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { IStepOption, TourMatMenuModule, TourService } from 'ngx-ui-tour-md-menu';
import { matTourSteps } from '../../model/matTour.model';
import { CamelCasePipe } from '../../utils/camel-case.pipe';

@Component({
  selector: 'app-custom-tour',
  standalone: true,
  imports: [TourMatMenuModule,MatCardModule,MatIconModule, CamelCasePipe],
  templateUrl: './custom-tour.component.html',
  styleUrl: './custom-tour.component.scss'
})
export class CustomTourComponent implements OnInit{
  public tourService = inject(TourService)
  readonly tourSteps:IStepOption[] = matTourSteps;
  ngOnInit(){
    this.tourService.initialize(this.tourSteps,{
      closeOnOutsideClick:false,
      enableBackdrop:true
    })
  }
}
